import {inject} from '@gongxigames/framework/core';
import {GlobalEventsMapForBackwardCompatibility} from '@gongxigames/framework/slot/events';
import {DI} from '@gongxigames/framework/slot/configs/DI';
import {IReelsScaleService} from '@gongxigames/framework/slot/types';
import {View} from '@gongxigames/framework/slot';

export class SelectBonusView extends View<GlobalEventsMapForBackwardCompatibility> {
    public static readonly NAME: symbol = Symbol('SelectBonusView');

    @inject(DI.ReelsScaleService)
    protected reelsScaleService!: IReelsScaleService;

    public init(): void {
        super.init();
    }

    public show(): void {}

    public hide(): void {}

    protected initGraphicElements(): void {}

    public onOrientationChanged(): void {
        super.onOrientationChanged();

        this.reelsScaleService.scaleByCurrentScreenOrientation(this.container);
    }
}
